import type {ProfileRelationsResource} from '~/types/infra/repository/ProfileRepositoryAPI';
import {ProfileRelationTypes} from '~/types/infra/repository/ProfileRepositoryAPI';

const experienceRelatedTypes = [
    ProfileRelationTypes.ONGOING_MISSION,
    ProfileRelationTypes.COMPLETED_MISSION,
    ProfileRelationTypes.ONGOING_EXPERIENCE,
    ProfileRelationTypes.PAST_EXPERIENCE,
];

const favoriteRelatedTypes = [ProfileRelationTypes.FAVORITE, ProfileRelationTypes.FAVORITE_OF_MINE];

export type ProfileRelationsDisplay = {
    withMe: boolean;
    otherCollaboratorNames: string[];
    isAddedAsFavorite: boolean;
};

export function profileRelationsDisplayMapper(relations: ProfileRelationsResource): ProfileRelationsDisplay {
    const experienceRelations =
        relations?.relations?.filter((relation) => experienceRelatedTypes.includes(relation.type) && relation.collaborator) ?? [];

    return {
        withMe: experienceRelations.some((relation) => relation.withMe),
        otherCollaboratorNames: [
            ...new Set(experienceRelations.filter((relation) => !relation.withMe).map((relation) => relation.collaborator!.name)),
        ],
        isAddedAsFavorite: relations?.relations?.some((relation) => favoriteRelatedTypes.includes(relation.type)) ?? false,
    };
}
